/*
 * @Author: 陈小英 13880788935@163.com
 * @Date: 2024-04-18 13:24:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-08 18:09:46
 * @FilePath: \operation-center\src\views\websiteAdmin\antireptileSet\components\frequencySet\business\filialeList.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { parseTime } from '@/utils/util'
export const searchForm = {
}

export const form = {
  line_id: undefined, // 业务线id
  platform: '',
  flag: '',
  type_id: undefined,
  contact: undefined,
  status: 1,
  control_type: 1,
  module_name: '',
}
export const formType = {
  name: '',
  format: undefined,
  status: 1,
}

export const rules = {
  line_id: [{ required: true, message: '请选择发布平台', trigger: 'change' }],
  platform: [{ required: true, message: '请选择平台分类', trigger: 'change' }],
  type_id: [{ required: true, message: '请选择类型', trigger: 'change' }],
  contact: [{ required: true, message: '请选择内容', trigger: 'change' }],
  flag: [{ required: true, message: '请输入标识', trigger: 'change' }],
  control_type: [{ required: true, message: '请选择控制配置', trigger: 'change' }],
  module_name: [{ required: true, message: '请输入模块名称', trigger: 'blur' }],
}
export const rulesType = {
  name: [{ required: true, message: '请输入类型名称', trigger: 'change' }],
  format: [{ required: true, message: '请选择类型格式', trigger: 'change' }],
}
